import { useGetRolodexEntriesByLoadOptions } from 'features/rolodex'
import { useMemo } from 'react'

type PipelineConfigStatusEntry = {
  entry: {
    id: string
  }
}

interface UseActivePipelineConfigIdResult {
  activePipelineConfigId: string | undefined
  isLoading: boolean
}

/**
 * The site's ACTIVE pipeline-config entry id, for callers that live outside
 * the documents page's `PipelineConfigProvider` (e.g. FIM evidence panels
 * building document-viewer links). Undefined for legacy (config-less) sites.
 */
export const useActivePipelineConfigId = (
  siteID: string | undefined
): UseActivePipelineConfigIdResult => {
  const loadOptions = useMemo(
    () =>
      siteID
        ? {
            type: ['pipeline-config'],
            tags: { site: siteID },
            filters: [
              { field: 'data', key: 'status', op: '=', value: 'active' },
            ],
            limit: 1,
          }
        : undefined,
    [siteID]
  )
  const { data } =
    useGetRolodexEntriesByLoadOptions<PipelineConfigStatusEntry[]>(loadOptions)

  return {
    activePipelineConfigId: data?.[0]?.entry.id,
    isLoading: siteID !== undefined && data === undefined,
  }
}
